import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../../shared/shared.module';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {FoodGuideEffects} from './core/food-guide.effects';
import {reducer} from './core/food-guide.reducer';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSortModule} from '@angular/material/sort';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {FoodGuideListScreenComponent} from './screen/food-guide-list-screen/food-guide-list-screen.component';
import {FoodGuideFormComponent} from './components/food-guide-form/food-guide-form.component';
import {FoodGuideAuditComponent} from './components/food-guide-audit/food-guide-audit.component';

@NgModule({
  declarations: [
    FoodGuideListScreenComponent,
    FoodGuideFormComponent,
    FoodGuideAuditComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('ss-cord.food-guide', reducer),
    EffectsModule.forFeature([FoodGuideEffects]),
    MatProgressSpinnerModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatExpansionModule,
    MatSortModule,
    InfiniteScrollModule,
  ],
})
export class FoodGuideManagementModule {
}
